import { Link } from 'react-router-dom';

import { Box, Typography } from '@mui/material';

import Button from '../Button/Button';
import { PlusIcon } from '../Dialogs/CollabsFilters/ToolTip';

export const UpgradePlanOverlay = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        bottom: 0,
        right: 0,
        minHeight: '312px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%)',
      }}
    >
      <Box
        sx={{
          borderRadius: '16px',
          border: '1px solid #DC4397',
          backgroundColor: '#FFF',
          boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.25)',
          minWidth: '800px',
          display: 'flex',
          alignItems: 'center',
          padding: '14px 18px',
          justifyContent: 'space-between',
          gap: '70px',
        }}
      >
        <Typography
          component={'span'}
          sx={{ color: '#222', fontSize: '16px', display: 'inline-block', fontWeight: 500 }}
        >
          Unlock access to 30,000+ models for exclusive collaborations
        </Typography>
        <Button
          component={Link}
          variant='contained'
          color='primary'
          sx={{ fontSize: '16px', fontWeight: 500, px: 2, py: 1.3 }}
          startIcon={<PlusIcon sx={{ height: '20px', width: '20px' }} />}
          to='/plans'
        >
          Upgrade plan
        </Button>
      </Box>
    </Box>
  );
};
